module.exports = __webpack_public_path__ + "static/media/dana_headshot.1396691a.jpg";